import { toggleMenuFieldProps } from "./types/toggleMenuFieldProps";
import { ReactComponent as ShowMenu } from '../../icons/view_comfy_alt.svg';
import { ReactComponent as HideMenu } from '../../icons/view_headline.svg';
import './toggleMenuField.scss';

const ToggleMenuField = (props: toggleMenuFieldProps) => {

    const onClickIcon = () => {
        props.setMenuOpened(!props.menuOpened);
    }

    const style: React.CSSProperties = { cursor: 'pointer', marginTop: 'auto' };

    const iconToggle = () => {
        if (props.menuOpened) return (<ShowMenu onClick={onClickIcon} style={style} />);
        return (<HideMenu onClick={onClickIcon} style={style} />);
    }

    return (<div className="toggleMenuField">{iconToggle()}</div>)
}

export default ToggleMenuField;